import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { faBook, faBookOpen, faSitemap } from "@fortawesome/free-solid-svg-icons";
import HubLinkCard from "../../common/HubLinkCard";

// El plan de cuentas y los libros solo están declarados en AccountingRoutes,
// así que estos accesos siguen yendo por /dashboard/accounting.
const cardsFor = (condominiumId) => {
  const base = `/dashboard/accounting/${condominiumId}`;
  return [
    {
      key: "plans",
      to: `${base}/account-plans`,
      icon: faSitemap,
      title: "Plan de cuentas",
      description: "Las cuentas en las que se clasifica cada ingreso y cada gasto.",
    },
    {
      key: "journal",
      to: `${base}/journal`,
      icon: faBook,
      title: "Libro diario",
      description: "Cada asiento contable, en orden de fecha.",
    },
    {
      key: "ledger",
      to: `${base}/ledger`,
      icon: faBookOpen,
      title: "Libro mayor",
      description: "El saldo y los movimientos de cada cuenta.",
    },
  ];
};

const FinanceAccountingLinks = ({ condominiumId }) => (
  <>
    <p className="text-700 mb-3">
      Los registros contables del condominio: cómo se clasifican las cuentas y los asientos
      de cada una.
    </p>
    <Row>
      {cardsFor(condominiumId).map(({ key, ...card }) => (
        <Col key={key} md={6} lg={4} className="mb-3">
          <HubLinkCard {...card} />
        </Col>
      ))}
    </Row>
  </>
);

FinanceAccountingLinks.propTypes = {
  condominiumId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default FinanceAccountingLinks;
